import { InvoiceType, RevenueType, TransactionType } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type RevenueApiType = ReturnType<typeof revenueApi>;

const revenueApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
    }: {
      limit: number;
      page: number;
      extraParams: {
        dateFrom?: string;
        dateTo?: string;
        invoiceType?: InvoiceType;
        transactionType?: TransactionType;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      };

      return axiosInstance.get(`${clubPrefix}revenue`, config);
    },
    csv(
      filters: {
        dateFrom?: string;
        dateTo?: string;
        invoiceType?: InvoiceType;
        transactionType?: TransactionType;
      },
      revenueType?: RevenueType,
    ) {
      return axiosInstance.get(
        `${clubPrefix}${revenueType ? `revenue/${revenueType}/csv` : `revenue/csv`}`,
        {
          params: filters,
        },
      );
    },
    total(
      filters: {
        dateFrom?: string;
        dateTo?: string;
        invoiceType?: InvoiceType;
        transactionType?: TransactionType;
      },
      revenueType?: RevenueType,
    ) {
      return axiosInstance.get(
        `${clubPrefix}${revenueType ? `revenue/${revenueType}/total` : `revenue/total`}`,
        {
          params: filters,
        },
      );
    },
    fetchRevenueByType(
      {
        limit,
        ...otherFilters
      }: {
        limit: number;
        page: number;
        dateFrom?: string;
        dateTo?: string;
        transactionType?: TransactionType;
        invoiceType?: InvoiceType;
      },
      revenueType: RevenueType = "transaction-type",
    ) {
      return axiosInstance.get(`${clubPrefix}revenue/${revenueType}`, {
        params: {
          size: limit,
          ...otherFilters,
        },
      });
    },
  };
};

export default revenueApi;
